import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse, NotFoundError } from "./ApiClient";
import { ReceivedInvoiceFormData, ReceivedInvoiceRelatedAttributes } from "@/formTypes/ReceivedInvoiceDataType";
import { ReceivedInvoiceFormDataKeys } from "@/generated/ReceivedInvoiceFormDataKeys";

export type ReceivedInvoiceDataType = Partial<ApiSchema["ReceivedInvoice"]["type"] & ReceivedInvoiceFormData>;

class Api extends GenericModelApi<"ReceivedInvoice", ReceivedInvoiceDataType> {

    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<ReceivedInvoiceDataType>> {
        const selectionSet = [
            ...ReceivedInvoiceFormDataKeys.filter(k => !ReceivedInvoiceRelatedAttributes.includes(k)),
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }

    async getReceivedInvoiceByEmailId(
        receivedEmailId: string,
        selectionSet?: any
    ): Promise<ReceivedInvoiceDataType> {

        const fetchFunction = ApiClient.models[this.modelName].listReceivedInvoiceByEmail;
        const { data, errors, nextToken: nt } = await fetchFunction({
            receivedEmailId: receivedEmailId,
        }, {
            limit: 1,
            selectionSet: selectionSet,
        });

        if (errors) {
            throw new ApiError("Error al obtenerla factura en base al correo electronico", "API_ERROR", errors);
        }

        const pageItems = (data || [])
        if (pageItems.length > 0) {
            return pageItems[0] as ReceivedInvoiceDataType
        }

        throw new NotFoundError(`No existe ningun factura con asociada al correo enviado`, "API_ERROR", errors);
    }
}
const api = new Api("ReceivedInvoice", "fecha", "DESC")
export const ReceivedInvoiceApi = api